import * as React from "react";
import { useContext, useCallback, useMemo } from "react";
import * as Immutable from "immutable";
import { useFormikContext } from "formik";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { ListingWithCount, NoSearchResult, PaginatedDataTable } from "components/common";
import { Alert, Input } from "components/bootstrap";
import ConnectionErrors from "components/authentication/directoryServices/BackendWizard/ConnectionErrors";
import OktaLoadMatchingGroupsButton from "./OktaLoadMatchingGroupsButton";
import OktaMatchingGroupsContext from "./OktaMatchingGroupsContext";
const ListWrapper = styled.div`
  position: relative;
`;
const TableRow = styled.tr(
  ({ clickable }) => `
  cursor: ${clickable ? "pointer" : "initial"};
`
);
const Checkbox = styled(Input)`
  && {
    min-height: auto;
    padding-top: 0;
  }
`;
const _tableRow = (group, selectionType, selectedGroupsIds, onGroupSelect) => {
  const { id, title, name, membersTotal, membersExcerpt } = group;
  const isSelected = selectionType === "all" || selectedGroupsIds.includes(id);
  const clickable = selectionType !== "all";
  return /* @__PURE__ */ React.createElement(TableRow, { onClick: () => clickable && onGroupSelect(id), clickable }, /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
    Checkbox,
    {
      type: "checkbox",
      id: `select-group-${id}`,
      onChange: () => {
      },
      checked: isSelected,
      disabled: selectionType === "all",
      formGroupClassName: ""
    }
  )), /* @__PURE__ */ React.createElement("td", { className: "limited" }, title), /* @__PURE__ */ React.createElement("td", { className: "limited" }, name), /* @__PURE__ */ React.createElement("td", { className: "limited" }, /* @__PURE__ */ React.createElement(ListingWithCount, { count: membersTotal, listing: membersExcerpt.join(", ") })));
};
const OktaMatchingGroupsOverview = ({ prepareSubmitPayload, onGroupSelect, disabled }) => {
  var _a, _b, _c, _d;
  const { t } = useTranslation("enterprise_authentication");
  const { result: loadedGroupsResult, finishedLoading } = useContext(OktaMatchingGroupsContext);
  const loadedGroups = (loadedGroupsResult == null ? void 0 : loadedGroupsResult.list) || Immutable.List();
  const loadedGroupsRows = useMemo(() => loadedGroups.toArray(), [loadedGroups]);
  const {
    values: { teamSelectionType, teamSelection }
  } = useFormikContext();
  const headerCellFormatter = useCallback((header) => /* @__PURE__ */ React.createElement("th", null, header), []);
  const tableHeaders = [
    t("oidc.okta_matching_groups_overview.table_headers.selected"),
    t("oidc.okta_matching_groups_overview.table_headers.title"),
    t("oidc.okta_matching_groups_overview.table_headers.name"),
    t("oidc.okta_matching_groups_overview.table_headers.members")
  ];
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "matchingGroups",
      label: t("oidc.okta_matching_groups_overview.label"),
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(OktaLoadMatchingGroupsButton, { prepareSubmitPayload, disabled }), finishedLoading && loadedGroupsResult && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("hr", null), loadedGroupsResult.success && /* @__PURE__ */ React.createElement(ListWrapper, null, ((_a = loadedGroupsResult == null ? void 0 : loadedGroupsResult.list) == null ? void 0 : _a.size) >= 1 && /* @__PURE__ */ React.createElement(
      PaginatedDataTable,
      {
        id: "matching-groups-list",
        headers: tableHeaders,
        headerCellFormatter,
        filterKeys: ["title"],
        noDataText: /* @__PURE__ */ React.createElement(NoSearchResult, null, t("oidc.okta_matching_groups_overview.no_groups")),
        rows: loadedGroupsRows,
        dataRowFormatter: (group) => _tableRow(group, teamSelectionType, teamSelection, onGroupSelect)
      }
    )), ((_b = loadedGroupsResult == null ? void 0 : loadedGroupsResult.errors) == null ? void 0 : _b.size) === 0 && ((_c = loadedGroupsResult == null ? void 0 : loadedGroupsResult.list) == null ? void 0 : _c.size) === 0 && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning" }, /* @__PURE__ */ React.createElement("b", null, loadedGroupsResult.message)), ((_d = loadedGroupsResult == null ? void 0 : loadedGroupsResult.errors) == null ? void 0 : _d.size) >= 1 && /* @__PURE__ */ React.createElement(ConnectionErrors, { errors: loadedGroupsResult.errors.toArray(), message: loadedGroupsResult.message })))
  );
};
export default OktaMatchingGroupsOverview;
